/**
 * GraphQL responses aren't supporting pagination. `pageInfo.endCursor` is not correct.
 * This is a temporary solution until the backend returns the correct cursor.
 * Returns the trade list cursor, given the trade point id, trade id and timestamp.
 * @param {string} tradePointId UUID expected
 * @param {string} tradeId UUID expected
 * @param {number} timestamp in unix timestamp
 * @returns {string|null} base64 encoded cursor
 */
const buildTradeListCursor = (tradePointId, tradeId, timestamp) => {
  if (!tradePointId || !tradeId || !timestamp) {
    return null;
  }
  const obj = { pk: { S: tradePointId }, sk: { S: `${timestamp}>>${tradeId}` } };

  return btoa(JSON.stringify(obj));
};

export default buildTradeListCursor;
